<template>
  <div class="select-tree">
    <p class="filter-tit">
      {{ fieldname }}
    </p>
    <div
      class="tree-data-desc border-bottom-1px"
      @click="showSelectTreePicker"
    >
      <span
        v-if="treeDataDesc"
        class="left"
        v-html="treeDataDesc"
      />
      <div
        v-else
        style="cursor: pointer;color: #d6d6d6;width: 100%;"
        class="left"
      >
        {{ $t('message["1413"]') }}{{ fieldname }}
      </div>
      <i class="iconfont icon-angle-right iconicon-test18" />
    </div>
    <cube-input
      :placeholder="enterPlaceholder"
      type="hidden"
    />
    <!-- <select-tree-pop
      ref="selectTreePicker"
      :options="treeData"
      child-key="children"
      :default-value="value"
      @select="selectTreeHandler"
      @cancel="cancelHandler"
      @confirm="confirmHandler"
    /> -->
  </div>
</template>

<script>
import SelectTreePop from '@/components/mobile/TreeSelect/TreeSelectPop'
import _ from 'lodash'
import Vue from 'vue'
import { createAPI } from 'cube-ui'
createAPI(Vue, SelectTreePop, ['select', 'cancel', 'confirm'], true)

export default {
  props: {
    data: {
      type: [Object, Array, String, Boolean],
      default: () => ({})
    },
    value: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      newValue: []
      // treeDataDesc: ''
    }
  },
  computed: {
    fieldname () {
      return this.data.fieldname
    },
    treeData () {
      return this.data.options
    },
    treeDataDesc () {
      const arr = this.newValue.map(item => {
        return `<em class="item-tag">${item.name}</em>`
      })
      return arr.join('')
    },
    enterPlaceholder () {
      return this.$t('message["751"]')
    }
  },
  created () {
    if (!this.instance) {
      this.instance = SelectTreePop.$create({
        $props: {
          options: this.treeData,
          defaultValue: Object.keys(this.value)
        },
        $attrs: {
          ref: 'selectTreePicker'
        },
        $class: {
          'selectTreePicker': true
        },
        $events: {
          select: this.selectTreeHandler,
          cancel: this.cancelHandler,
          confirm: this.confirmHandler
        }
      })
    }
    this.newValue = _.reduce(this.data.fieldvalue, (res, item, k) => {
      let obj = {
        id: k,
        name: item
      }
      res.push(obj)
      return res
    }, [])
  },
  methods: {
    showSelectTreePicker () {
      this.instance && this.instance.show()
      // this.$refs.selectTreePicker.show()
    },
    selectTreeHandler (selectedList = []) {
      this.newValue = selectedList
      this.data.fieldvalue = _.reduce(selectedList, (res, item) => {
        res[item.id] = item.name
        return res
      }, {})
      this.$emit('change', this.data.fieldvalue)
    },
    cancelHandler () { },
    confirmHandler (selectedVal) { }
  }
}
</script>

<style lang="scss" scoped>
.select-tree::v-deep {
  .tree-data-desc {
    // border-top: 1px solid #dbdbdb;
    display: flex;
    justify-content: space-between;
    height: 56px;
    line-height: 56px;
    padding: 0 16px;
    color: #333;
    font-size: 16px;
    .iconicon-test18 {
      color: #d6d6d6;
    }
  }
}
</style>
